import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Afp, RequestResponseGetAllAfp, RequestResponseActualizar } from 'src/app/shared/models/afps.interface';


@Injectable({
  providedIn: 'root'
})
export class AfpService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_afps
  traerAfps(): Observable<RequestResponseGetAllAfp> {
    return this.http
    .get<RequestResponseGetAllAfp >(`${environment.API}/rrhh/afp/`)
    .pipe(
      map((res:RequestResponseGetAllAfp) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }

  //Create_afp
  crearAfp(afp:Afp): Observable<RequestResponse> {      
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/afp/crear`,afp)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_afp
  actualizarAfp(afp:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/afp/actualizar/${afp.id}`,afp)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_afp
  traerAfpPorId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/afp/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Eliminar_afp
  eliminarAfp(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/afp/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }


  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }

}




